import { ClearCache, Session } from 'smg/customer-api/session';
import { CategoryDescriptionsFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
import { InitSmsPreferencesPanel } from 'smg/sms-preferences-panel';

import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }
    InitEmailPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument() });
    const smsPanel = InitSmsPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument('#sprefs-categories') });

    // The session names the account and the number texts go to. The guard
    // lets the page open on a non-auth session failure (the preferences load
    // on their own), so that failure gets its own retry here: the cached
    // rejection has to be cleared or Session() hands it straight back.
    const $owner = document.querySelector('#notif-owner') as HTMLElement;
    const $email = document.querySelector('#notif-email') as HTMLElement;
    const $destinationFailed = document.querySelector('#sprefs-destination-failed') as HTMLElement;
    const $destinationRetry = document.querySelector('#sprefs-destination-retry') as HTMLButtonElement;
    function loadOwner() {
        $destinationFailed.classList.add('d-none');
        void Session().then(sess => {
            $email.textContent = sess.user.emailAddress.email ?? '';
            $owner.classList.remove('d-none');
            smsPanel.setPhone(sess.user.phoneNumber.phone ?? '');
        }).catch(() => {
            $destinationFailed.classList.remove('d-none');
        });
    }
    $destinationRetry.addEventListener('click', () => {
        ClearCache();
        loadOwner();
    });
    loadOwner();
}
